import { axiosApi } from 'shared/api/axios'
import { NomenclaturesEndpoint } from './constants'
import { setUTCTimezone } from 'shared/utils/timezone'

export const getNomenclaturesAvailableCount = async (id: number | string, start: Date, end: Date) => {
    try {
        const response = await axiosApi.get<{ count: number }>(
            `${NomenclaturesEndpoint.nomenclatureAvailableCount}/${id}`,
            {
                params: {
                    start_time: setUTCTimezone(start).toISOString(),
                    end_time: setUTCTimezone(end).toISOString(),
                }
            }
        )
        return response.data.count
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка загрузки оборудования')
    }
}
